export const MOVIES_DB_KEY = 'a5564d61ca5ae8b77688cf841496b7d0';
export const OMDB_KEY = '14788c11';

export function checkKey(key, name) {
  if (!key) {
    throw new Error(`${name ? name : 'Api'} key is not valid!`);
  }
}
